/**
 * Bouton burger du header (.header__nav-icon--burger), affiché à toutes les largeurs.
 * - Vue desktop : le label coche .header__menu-toggle, qui ouvre le menu latéral du thème.
 * - Vue mobile de l'app CWS Mega Menu (#cwsMenuMobile affiché) : le clic est redirigé
 *   vers le bouton d'ouverture de l'app (.cwsmobile-menubar-toggle), masqué en CSS.
 */
(function () {
  'use strict';

  function getMobileMenuToggle() {
    var mobileMenu = document.getElementById('cwsMenuMobile');

    if (!mobileMenu || window.getComputedStyle(mobileMenu).display === 'none') {
      return null;
    }

    return mobileMenu.querySelector('.cwsmobile-menubar-toggle');
  }

  document.addEventListener('click', function (event) {
    if (!event.target.closest('.header__nav-icon--burger')) {
      return;
    }

    var mobileMenuToggle = getMobileMenuToggle();

    if (!mobileMenuToggle) {
      return;
    }

    event.preventDefault();
    mobileMenuToggle.click();
  });
})();
